export default {
    edit: 'Edit',
    download: 'Download'
}
